import React from 'react';
import { StyledText } from './styles/Text.styles';

const TextControl = ({ control }) => (
  <StyledText styleProps={control.attributes}>
    {control.isHtml ? (
      <div dangerouslySetInnerHTML={{ __html: control.text }} />
    ) : (
      control.text
    )}
  </StyledText>
);

export default TextControl;